<template>
  <div>
    <v-button type="primary"
              ghost
              @click="backManager"
              icon="left"
              style="float:right">返回列表</v-button>
    <div style="height:20px;"></div>
    已启用的规格
    <div style="height:20px;"></div>
    <el-table :data="tableData1"
              style="width: 99%">
      <el-table-column prop="spec_id"
                       label="规格ID">
      </el-table-column>
      <el-table-column prop="spec_name"
                       label="规格名称">
      </el-table-column>
      <el-table-column prop="px_size"
                       label="像素大小">
      </el-table-column>
      <el-table-column prop="weights"
                       label="规格权重">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text"
                     @click="removeSpec(scope.row)"
                     size="small">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="height:40px;"></div>
    已禁用的规格
    <div style="height:20px;"></div>
    <el-table :data="tableData2"
              style="width: 99%">
      <el-table-column prop="spec_id"
                       label="规格ID">
      </el-table-column>
      <el-table-column prop="spec_name"
                       label="规格名称">
      </el-table-column>
      <el-table-column prop="px_size"
                       label="像素大小">
      </el-table-column>
      <el-table-column prop="weights"
                       label="规格权重">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text"
                     @click="removeSpec(scope.row)"
                     size="small">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      groupName: this.$route.query.groupName,
      tableData1: [],
      tableData2: []
    }
  },
  methods: {
    removeSpec (row) {
      axios.get('/dev/spec_remove_group/' + row.spec_id)
        .then(res => {
          this.$message['success']('移除成功')
          this.inintData()
        })
    },
    backManager () {
      this.$router.push('/main/formatManager')
    },
    handleClick () {
      this.$router.push('/main/formatEdit')
    },
    inintData () {
      console.log(this.groupName)
      let url = '/dev/group_spec/' + this.groupName
      axios.get(url)
        .then(res => {
          res.data.specs.normal_spec.forEach(element => {
            element.px_size = element.px_size[0] + '*' + element.px_size[1]
          })
          res.data.specs.disable_spec.forEach(element => {
            element.px_size = element.px_size[0] + '*' + element.px_size[1]
          })
          this.tableData1 = res.data.specs.normal_spec
          this.tableData2 = res.data.specs.disable_spec
        })
    }
  },
  created () {
    this.inintData()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/format/format-view.vue